<div class="dialog">
  @if (loading()) {
    <div class="loading-overlay">
      <mat-progress-spinner mode="indeterminate" diameter="40" />
    </div>
  }
  <div class="dialog__header">
    <h2>{{ 'customers.editCustomer.title' | translate }}</h2>
    <button class="dialog__header-close" type="button" (click)="onCancel()" aria-label="Close">
      <app-icon [icon]="IconName.CLOSE" />
    </button>
  </div>

  <form class="form" [formGroup]="form" (ngSubmit)="onSave()">
    <div class="form-fields">
      <div class="field">
        <mat-label>{{ 'customers.editCustomer.firstName' | translate }}</mat-label>
        <mat-form-field appearance="outline">
          <input matInput formControlName="firstName" type="text" />

          @if (form.get('firstName')?.touched && getErrorMessageForCustomer('firstName')) {
            <mat-error>
              {{ getErrorMessageForCustomer('firstName') | translate }}
            </mat-error>
          }
        </mat-form-field>
      </div>

      <div class="field">
        <mat-label>{{ 'customers.editCustomer.lastName' | translate }}</mat-label>
        <mat-form-field appearance="outline">
          <input matInput formControlName="lastName" type="text" />

          @if (form.get('lastName')?.touched && getErrorMessageForCustomer('lastName')) {
            <mat-error>
              {{ getErrorMessageForCustomer('lastName') | translate }}
            </mat-error>
          }
        </mat-form-field>
      </div>

      <div class="field">
        <mat-label>{{ 'customers.editCustomer.email' | translate }}</mat-label>
        <mat-form-field appearance="outline">
          <input matInput formControlName="email" type="email" />

          @if (form.get('email')?.touched && getErrorMessageForCustomer('email')) {
            <mat-error>
              {{ getErrorMessageForCustomer('email') | translate }}
            </mat-error>
          }
        </mat-form-field>
      </div>

      <div class="field">
        <mat-label>{{ 'customers.createCustomer.phoneNumber.label' | translate }}</mat-label>
        <div class="phone-field" [class.has-error]="hasPhoneError">
          <mat-form-field appearance="outline" class="phone-field__country">
            <mat-select formControlName="countryId">
              <mat-select-trigger>
                <span class="phone-field__country-code">
                  {{ getSelectedPhoneCode() }}
                </span>
              </mat-select-trigger>

              @for (country of countries; track country.id) {
                <mat-option [value]="country.id">
                  {{ country.name }} ({{ country.phoneCode }})
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
          <mat-form-field appearance="outline" class="phone-field__number">
            <input
              matInput
              id="phoneNumber"
              formControlName="phoneNumber"
              type="tel"
              [placeholder]="'customers.createCustomer.phoneNumber.placeholder' | translate"
            />
          </mat-form-field>
        </div>
        @if (hasPhoneError) {
          <div class="phone-field__error">
            {{
              getErrorMessageForCustomer('countryId') || getErrorMessageForCustomer('phoneNumber')
                | translate
            }}
          </div>
        }
      </div>
    </div>

    <div class="field">
      <mat-label>{{ 'customers.editCustomer.loyaltyId' | translate }}</mat-label>
      <mat-form-field class="loyalty-field" appearance="outline">
        <input class="loyalty-input-disabled" matInput formControlName="loyaltyId" type="text" />
      </mat-form-field>
    </div>

    <div class="field">
      <mat-label>{{ 'customers.editCustomer.remarks' | translate }}</mat-label>
      <mat-form-field appearance="outline">
        <textarea matInput formControlName="remarks" class="remarks-input" rows="5"></textarea>
      </mat-form-field>
    </div>

    <div class="activate-checkbox">
      <mat-slide-toggle formControlName="isActive" [hideIcon]="true">
        {{ 'customers.editCustomer.activated' | translate }}
      </mat-slide-toggle>
    </div>

    <div class="form-actions">
      <button type="button" class="btn-delete" (click)="handleCustomerDetele()">
        {{ 'customers.editCustomer.deleteCustomer' | translate }}
      </button>
      <div class="right-buttons">
        <button type="button" class="btn-cancel" (click)="onCancel()">
          {{ 'customers.editCustomer.cancel' | translate }}
        </button>
        <button type="submit" class="btn-save">
          {{ 'customers.editCustomer.save' | translate }}
        </button>
      </div>
    </div>
  </form>
</div>
